import { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';
import { Root } from '@routes';
import { PopupLayer } from '@shared/widgets';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const App = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <PopupLayer mode='single' />
        <Root />
      </BrowserRouter>
    </ErrorBoundary>
  );
};
